<template>
    <el-dialog
        title="审核确认"
        :visible.sync="dialogVisible"
        width="80%"
        :close-on-click-modal="false"
        :close="handleClose">
        <template>
            <div class="main-body">
                <el-row>
                    <el-form :inline="true" :model="fromData" class="demo-form-inline">
                        <el-form-item label="选择主体">
                            <el-select v-model="fromData.mainBody" :disabled="mainDisabled" placeholder="选择主体"
                                       @change="getMainOptions">
                                <el-option
                                    v-for="item in mainOptions"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="选择仓库">
                            <el-select v-model="fromData.wsId" placeholder="活动区域" @change="getLocOptions">
                                <el-option
                                    v-for="item in distOptions"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="选择仓位">
                            <el-select v-model="fromData.locId" placeholder="活动区域" @change="getSkuStock">
                                <el-option
                                    v-for="item in locOptions"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-row v-for="(order,index) in orderList" :key="index" style="margin-bottom: 20px">
                    <el-row style="margin-bottom: 10px">订单号: {{ order.orderNo }}</el-row>
                    <el-row>
                        <el-table
                            :data="order.items"
                            :span-method="spanMethod"
                            :row-class-name="tableRowClassName"
                            v-loading="isLoading"
                            border
                            style="width: 100%">
                            <el-table-column
                                prop="barCode"
                                label="69码"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                prop="skuName"
                                label="商品名称">
                            </el-table-column>
                            <el-table-column
                                prop="orderAmount"
                                label="下单数量">
                                <template slot-scope="scope">
                                    {{ scope.row.orderAmount }}{{ scope.row.unit }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="sendSkuName"
                                label="发货商品">
                            </el-table-column>
                            <el-table-column
                                prop="sendAmount"
                                label="发货数量">
                                <template slot-scope="scope">
                                    <el-input placeholder="请输入内容" v-model="scope.row.sendAmount"
                                              @change="inputStock(scope.row, order.items)">
                                        <template slot="append">{{ scope.row.sendSkuUnit }}</template>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="actualAmount"
                                label="可用库存">
                            </el-table-column>
                            <el-table-column
                                prop="actualAmountEnd"
                                label="发货后库存">
                            </el-table-column>
                        </el-table>
                    </el-row>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="confirmReview">确认审核</el-button>
              </span>
        </template>
    </el-dialog>
</template>

<script>
import {
    WmsWarehouseApi,
    Mod_Warehouse_Types_Options //库存类型
} from '@/modules/server-api/wms-manage/warehouse';
import {OrderApi} from '@/modules/server-api/commodity-sys/order';

export default {
    props: {
        orders: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            orderNos: [],
            fromData: {mainBody: null},
            mainOptions: [],
            distOptions: [],
            locOptions: [],
            formInline: {},
            tableData: [],
            dialogVisible: false,
            mainDisabled: false,
            loading: true,
            orderList: [],
            bodyId: null,
            isLoading: false,
            stocks: {}
        }
    },
    created() {
        this.getMainList();
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible == false) {
                this.fromData.wsId = '';
                this.fromData.locId = '';
            }
        }
    },
    methods: {
        open(orderNos) {
            this.dialogVisible = true;
            this.orderNos = orderNos;
            this.getOrders();
        },
        getOrders() {
            console.log(this.orders);
            OrderApi.reviewDetail({orderNos: this.orderNos}).then(res => {
                console.log(res)
                if (res.succ === 1) {
                    console.log(res);
                    let result = res.result;
                    this.orderList = result.map(item => {
                        let order = {};
                        order.orderNo = item.orderNo;
                        order.bodyId = item.bodyId;
                        order.items = this.getOrderByDesc(item.orderReviewDetailBoList);

                        return order;
                    });
                    console.log(this.orderList,"orderList")

                    this.bodyId = this.fromData.mainBody = this.orderList[0].bodyId;
                    this.getMainOptions(this.bodyId);
                    this.mainDisabled = true;
                } else {
                    this.dialogVisible = false
                    this.$notifyError(res.error);
                }
            })
        },
        getOrderByDesc(details) {
            return details.map(detail => {
                //加一个订单应发数量 用来做数量校验
                detail.shouldNum= Number(detail.sendAmount);
                detail.actualAmount = detail.actualAmount || 0;
                detail.actualAmountEnd = detail.actualAmountEnd || 0;
                detail.orderAmount = parseInt(detail.orderAmount);
                detail.warning = false;
                return detail;
            })
        },
        spanMethod({row, column, rowIndex, columnIndex}) {
            if (columnIndex < 3) {
                if (row.split) {
                    if (row.split === 1) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        }
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                } else {
                    // console.log(34333)
                    return {
                        rowspan: 1,
                        colspan: 1
                    };
                }
            }
        },
        tableRowClassName({row, rowIndex}) {
            if (row.warning) {
                return 'warning-row';
            }
            return '';
        },
        getMainList() {
            WmsWarehouseApi.getAllMainBody({}).then(res => {
                console.log("getAllMainBody", res)
                if (res.code === 0 && res.succ === 1) {
                    let result = res.result;
                    this.mainOptions = result.map(item => {
                        let obj = {};
                        obj.id = item.id;
                        obj.label = item.name;
                        return obj;
                    });
                }
            })
        },
        //获取分仓
        async getMainOptions() {
            let bodyId = this.bodyId;
            if (bodyId) {
                let resp = await WmsWarehouseApi.getWarehouseAll({
                    bodyId: bodyId,
                    suggest: '',
                    type: Mod_Warehouse_Types_Options[2].id
                });
                this.distOptions = resp.result.map(item => {
                    let obj = {};
                    obj.id = item.wsId;
                    obj.label = item.wsName;
                    return obj;
                });
            }
        },
        //获取仓位
        getLocOptions(wsId) {
            console.log(wsId)
            if (wsId) {
                WmsWarehouseApi.getLocAll({
                    wsId: wsId
                }).then(res => {
                    if (res.succ === 1) {
                        this.fromData.locId = ''
                        this.locOptions = res.result.map(item => {
                            let obj = {};
                            obj.id = item.id;
                            obj.label = item.locName;
                            return obj;
                        })
                    }
                });
            }
        },
        getSkuStock(locId) {
            this.isLoading = true
            OrderApi.skuStocks({locId: locId, orderNos: this.orderNos}).then(res => {
                if (res.succ === 1) {
                    let result = res.result;
                    this.stocks = {};
                    result.map(stock => {

                        this.orderList.map(detail => {
                            if (detail.orderNo === stock.orderNo) {
                                stock.wmsOrderReviewStockBoList.map(dd => {
                                    detail.items.map(item => {
                                        if (item.sendBarCode === dd.sendBarCode) {
                                            item.actualAmount = parseInt(dd.actualAmount);
                                            item.actualAmountEnd = parseInt(dd.actualAmount) - item.sendAmount;

                                            this.stocks[dd.sendBarCode] = parseInt(dd.actualAmount);

                                            console.log('111111' , dd, item.sendAmount)
                                        }
                                    })
                                })
                            }
                        })
                    })

                    console.log( 'get stock ', this.stocks)
                    this.isLoading = false
                }

            })

        },
        handleClose() {
            this.dialogVisible = false;
            this.$parent.clickOrderNo = '';
            this.$parent.getOrderformList();
            this.distOptions = [];
            this.locOptions = [];
            this.fromData.wsId = '';
            this.fromData.locId = '';
        },
        confirmReview() {

            let params = {
                bodyId: this.bodyId,
                orderNos: [],
                orders: []
            }
            let allStock = Object.create(this.stocks);
            let orderItems = [];
            let isSubmit = true;
            console.log(this.orderList)
            //过滤订单数据
            this.orderList.map(order => {
                let isOrderSubmit = true;
                let items = {};
                let orderStock={};
                order.items.map(item => {
                    if (items[item.barCode]) {
                        items[item.barCode].skuAmounts = this.calculateSku(item, items[item.barCode].skuAmounts);
                    } else {
                        items[item.barCode] = {
                            orderNo: order.orderNo,
                            wsId: this.fromData.wsId,
                            locId: this.fromData.locId,
                            skuAmounts: this.calculateSku(item, null)
                        }
                    }
                    this.inputStock(item, order.items);

                    //临时存储
                    orderStock[item.sendBarCode] = item.sendAmount;

                    if (item.warning) {
                        isSubmit = false;
                    }
                    console.log(allStock)
                    if ( allStock[item.sendBarCode] < item.sendAmount){
                        isOrderSubmit = false;
                        isSubmit = false;
                    }
                });

                //当前订单是否库存不足，不继续处理
                if (isOrderSubmit){
                    Object.keys(orderStock).map(key =>{
                        allStock[key] -= orderStock[key];
                    });

                    Object.keys(items).map(key => {
                        orderItems.push(items[key]);
                    });
                    params.orderNos.push(order.orderNo);
                }
            });

            params.orders = this.mergeResult(orderItems);
            console.log( params )
            if ( params.orderNos.length > 0 && !isSubmit ){
                this.$confirm('有库存不足的订单是否继续审核', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    OrderApi.batchReview(params).then(res => {
                        if (res.succ === 1) {
                            this.$notifySuccess('审核成功');
                            this.handleClose();
                        } else {
                            this.$notifyError(res.error);
                        }
                    })
                });
            }else if (isSubmit){
                OrderApi.batchReview(params).then(res => {
                    if (res.succ === 1) {
                        this.$notifySuccess('审核成功');
                        this.handleClose();
                    } else {
                        this.$notifyError(res.error);
                    }
                })
            }
        },
        calculateSku(item, skuAmount) {
            // console.log(item, skuAmount)
            const skuCode = item.skuCode;
            skuAmount = skuAmount || [];
            let isCalculate = true;
            skuAmount = skuAmount.map(amount => {
                if (amount.skuCode === skuCode) {
                    if (item.sendSkuUnit === '箱') {
                        amount.boxNum = parseInt(item.sendAmount);
                    } else {
                        amount.caseNum = parseInt(item.sendAmount);
                    }
                    isCalculate = false;
                }
                return amount;
            });

            if (isCalculate) {
                let amount = {skuCode: skuCode};
                if (item.sendSkuUnit === '箱') {
                    amount.boxNum = parseInt(item.sendAmount);
                } else {
                    amount.caseNum = parseInt(item.sendAmount);
                }
                skuAmount.push(amount);
            }

            return skuAmount;
        },
        inputStock(row, items) {
            console.log(row,items)
            row.sendAmount = row.sendAmount && !isNaN(row.sendAmount) ? parseInt(row.sendAmount) : 0;
            row.actualAmountEnd = row.actualAmount - row.sendAmount;

            let order = {};
            order.barCode = row.barCode;
            order.orderAmount = row.orderAmount;
            order.boxNum = 0;
            order.unitNum = 0;
            order.boxSpec = 0;
            order.boxOrderAmount = 0;
            order.skuName = '';
            items.map(item => {
                if (item.barCode === row.barCode) {
                    order.skuName = item.skuName;
                    if (item.unit === '箱') {
                        order.boxOrderAmount = parseInt(item.sendAmount);
                    } else if (item.sendSkuUnit === '箱') {
                        order.boxNum = parseInt(item.sendAmount);
                        order.boxSpec = item.boxSpec;
                    } else {
                        order.unitNum = parseInt(item.sendAmount);
                    }
                }
            });

            items.map(item => {
                if (item.barCode === row.barCode) {
                    item.warning = false;
                    item.warning = item.sendAmount > item.actualAmount;
                    item.warning = !(item.actualAmountEnd >= 0)
                    if (item.warning) {
                        this.$notifyError(item.skuName + "库存不够");
                    }
                }
            });
            // console.log( '----', order, items)
            if (order.boxNum * order.boxSpec + order.unitNum + order.boxOrderAmount !== order.orderAmount) {

                items.map(v=>{
                  if(v.shouldNum!=v.sendAmount){
                    v.warning=true
                    this.$notifyError(v.skuName + "审核数量和下单数量不一致");
                  }
                })

                // row.warning = true;
                // console.log(this.orderList)
                // this.$notifyError(order.skuName + "审核数量和下单数量不一致");
            }
        },
        mergeResult(orderItems) {
            let result = {};
            orderItems.map(item => {
                if (result[item.orderNo]) {
                    result[item.orderNo].skuAmounts = result[item.orderNo].skuAmounts.concat(item.skuAmounts);
                } else {
                    result[item.orderNo] = item;
                }
            });

            return Object.keys(result).map(key => {
                return result[key];
            })
        }
    }
}
</script>
<style>
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.main-body {
    max-height: 400px;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
}

.main-body::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}
</style>
